import { IAmericanDigitalShortFormData } from './IAmericanDigitalShortFormData';

export const selectIsReadyToCreateShortFormPolicy = (data: IAmericanDigitalShortFormData): boolean => {
  return !!(
    data.policy_number &&
    data.amount_of_insurance &&
    data.premiums &&
    data.premiums.length === 1 &&
    data.mortgage_date
  );
};
